import React, { useContext, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Context } from "../../index";
import { Helmet } from "react-helmet";
import AddFundsPay from "../../components/payment/AddFundsPay";
import AddFundsImage from "../../assets/virtalibry_add_funds.png"

const fundOptions = [
    {
        name: "ADD $5 USD",
        addPriceId: process.env.REACT_APP_STRIPE_PRICE_ADD_5,
        amount: 5,
        bonus: 0,
        logo: AddFundsImage,
        description: "Perfect for testing the platform."
    },
    {
        name: "ADD $15 USD",
        addPriceId: process.env.REACT_APP_STRIPE_PRICE_ADD_15,
        amount: 15,
        bonus: 0,
        logo: AddFundsImage,
        description: "Perfect for testing the platform."
    },
    {
        name: "ADD $25 USD",
        addPriceId: process.env.REACT_APP_STRIPE_PRICE_ADD_25,
        amount: 25,
        bonus: 0,
        logo: AddFundsImage,
        description: "Great for running a few polls."
    },
    {
        name: "ADD $50 USD",
        addPriceId: process.env.REACT_APP_STRIPE_PRICE_ADD_50,
        amount: 50,
        bonus: 0,
        logo: AddFundsImage,
        description: "Ideal for active users."
    },
    {
        name: "ADD $100 USD",
        addPriceId: process.env.REACT_APP_STRIPE_PRICE_ADD_100,
        amount: 100,
        bonus: 0,
        logo: AddFundsImage,
        description: "Maximum value for professional users."
    },
    {
        name: "ADD $500 USD",
        addPriceId: process.env.REACT_APP_STRIPE_PRICE_ADD_500,
        amount: 500,
        bonus: 0,
        logo: AddFundsImage,
        description: "Perfect for testing the platform."
    },
];

const AddFundsToUsdBalance = () => {
    const { user } = useContext(Context);
    const [selectedAmount, setSelectedAmount] = useState(null);
    const [selectedAddPrice, setSelectedAddPrice] = useState(null);


    return (
        <>
            {selectedAddPrice ? (
<AddFundsPay priceId={selectedAddPrice}/>
            ): (
                <>


            <Helmet>
                <title>Add Funds to USD Balance</title>
            </Helmet>
            <Container style={{ maxWidth: "1200px" }} className="w-100">
                <Row className="justify-content-center">
                    <Col xs={12} className="text-center mb-4">
                        <h2 className="text-success">Add Funds to Your Balance</h2>
                        <p className="text-muted">Select an amount and instantly top up your USD balance.</p>
                    </Col>

                    {fundOptions.map(option => (
                        <Col key={option.name} xs={12} sm={6} md={2} lg={2} className="mb-4 d-flex justify-content-center">
                            <Card
                                className={`shadow ${selectedAmount === option.amount ? "border-success" : ""}`}
                                style={{
                                    borderRadius: "6px",
                                    transition: "transform 0.2s, box-shadow 0.2s",
                                    cursor: "pointer",
                                    width: "100%",
                                    maxWidth: "280px",
                                    transform: selectedAmount === option.amount ? "translateY(-5px)" : "translateY(0)",
                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",

                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = "0px 6px 16px rgba(0, 0, 0, 0.2)";
                                    e.currentTarget.style.transform = "translateY(-5px)";
                                }}
                                onMouseLeave={(e) => {
                                    if (selectedAmount !== option.amount) {
                                        e.currentTarget.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.1)";
                                        e.currentTarget.style.transform = "translateY(0)";
                                    }
                                }}
                                onClick={() => setSelectedAmount(option.amount)}
                            >
                                <Card.Body className="d-flex flex-column align-items-center text-center">
                                    <img
                                        src={option.logo}
                                        alt={`${option.name} Plan`}
                                        className="img-fluid mb-3"
                                        style={{ maxHeight: "170px" }}
                                    />
                                    <h5 className="fw-bold text-success">{option.name}</h5>


                                    <Button
                                        className="mt-3"
                                        variant="outline-success"

                                        onClick={() => {
                                           setSelectedAddPrice(option.addPriceId);
                                        }}
                                    >
                                       <strong>{option.name}</strong>
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
                </>
            )}
        </>
    );
};

export default AddFundsToUsdBalance;